// Generated by ts-to-zod
import { z } from 'zod';
import { urlSchema } from '../../utils/codecUtils.schema';

export const processingDurationSchema = z.object({
  annotation: urlSchema.optional(),
  timeSpentActive: z.number().optional(),
  timeSpentOverall: z.number().optional(),
  timeSpentEdit: z.number().optional(),
  timeSpentEmails: z.number().optional(),
  timeSpentBlockers: z.number().optional(),
  timeSpentOpening: z.number().optional(),
  durationLatestValidateStarted: z.number().nullable().optional(),
  durationLatestValidateUpdatedBeforeConfirm: z.number().nullable().optional(),
});
